import { FC } from "react";
import { debounce } from "lodash";
import { SelectBox } from "../../../components";
import { LookupItemModel } from "../../../models";

interface AutoCompleteSearchBoxProps {
  id: string;
  labelName: string;
  isDisabled?: boolean;
  isSingleSelect?: boolean;
  selectedValue?: string | null;
  items: LookupItemModel[];
  debounceTime?: number;
  onItemSelected: (item: LookupItemModel | null) => void;

  onSearch?: (searchValue: string) => Promise<void>;
}

export const AutoCompleteSearchBox: FC<AutoCompleteSearchBoxProps> = ({
  id,
  labelName,
  isDisabled = false,
  isSingleSelect = true,
  selectedValue = null,
  items = [],
  debounceTime = 600,
  onItemSelected,
  onSearch,
  ...props
}) => {
  const handleInputChange = (inputValue: string) => {
    if (onSearch) {
      debouncedSearch(inputValue);
    }

    return inputValue;
  };

  // Create debounced search function
  const debouncedSearch = debounce(async (searchValue: string) => {
    if (onSearch) {
      await onSearch(searchValue);
    }
  }, debounceTime);

  const handleSelectionChange = (selected: LookupItemModel) => {
    onItemSelected(selected?.value ? selected : null);
    onSearch?.("none");
  };

  return (
    <SelectBox
      id={id}
      labelName={labelName}
      isSingleSelect={isSingleSelect}
      isDisabled={isDisabled}
      selectedValues={selectedValue ? [selectedValue.toString()] : []}
      source={items}
      onInputChange={handleInputChange}
      onStatusChange={handleSelectionChange}
      {...props}
    />
  );
};
